
export const datatableMixin = {
  methods: {
    //下载
    exportToExcel(table, filename) {
        this.$refs[table].exportToExcel(filename)
    },
    //复制
    copy(table) {
        this.$refs[table].copy()
    },
  }
}
